<template>
  <div class="filter">
    <div class="spans"></div>
    <p class="clear" @click="clear">clear</p>
  </div>
  <div
    v-for="(person, index) in filter"
    :key="index"
    class="job"
    :class="{ featured: person.featured }"
  >
    <div class="company">
      <div>
        <img :src="require(`../assets/images/${person.logo}`)" alt="" />
      </div>
      <div class="text">
        <div class="first-line">
          <span class="name">{{ person.company }}</span>
          <span v-if="person.new" class="new">NEW!</span>
          <span v-if="person.featured" class="featured">FEATURED</span>
        </div>
        <h3>{{ person.position }}</h3>
        <div class="last-line">
          <span>{{ person.postedAt }}</span>
          <span>{{ person.contract }}</span>
          <span>{{ person.location }}</span>
        </div>
      </div>
    </div>
    <div class="lang">
      <ul>
        <li
          v-for="(lan, index) in person.languages"
          :key="index"
          @click="add"
          class="language"
        >
          {{ lan }}
        </li>
        <li
          v-for="(tool, index) in person.tools"
          :key="index"
          @click="add"
          class="tool"
        >
          {{ tool }}
        </li>
        <li
          v-for="(position, index) in person.position
            .split(` `)
            .slice(0, index)"
          :key="index"
          @click="add"
          class="position"
        >
          {{ position }}
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import data from "../assets/data.json";
import removeIm from "../assets/images/icon-remove.svg";
export default {
  name: "Person",
  data() {
    return {
      data: [],
      names: [],
      len: 0,
    };
  },
  mounted() {
    this.data = data;
  },
  methods: {
    add(e) {
      let spans = document.querySelector(`.spans`),
        span = document.createElement(`span`),
        button = document.createElement(`button`),
        remove = document.createElement(`img`);
      if (!this.names.includes(e.target.innerHTML)) {
        span.innerHTML = e.target.innerHTML;
        span.classList.add(e.target.classList[0]);
        button.setAttribute(`class`, e.target.innerHTML);
        spans.appendChild(span);
        remove.setAttribute(`src`, removeIm);
        button.appendChild(remove);
        spans.appendChild(button);
        this.names.push(span.innerHTML);
        this.len += 1;
      }
      button.addEventListener(`click`, (event) => {
        let filterNames = document.querySelectorAll(`.spans span`);
        filterNames.forEach((element) => {
          if (element.innerHTML === event.currentTarget.classList[0]) {
            element.remove();
            this.names = this.names.filter(
              (name) => name !== element.innerHTML
            );
          }
          event.currentTarget.remove();
        });
        this.len -= 1;
        console.log(this.len);
      });
    },
    clear() {
      let childrenFilter = document.querySelector(`.spans`).children;
      Array.from(childrenFilter).forEach((element) => {
        element.remove();
        this.names = this.names.filter((name) => name !== element.innerHTML);
      });
    },
  },
  computed: {
    filter() {
      let filterNames = document.querySelectorAll(`.spans span`);
      if (this.len === 0) {
        return this.data;
      } else {
        let afterFiter;
        filterNames.forEach((element) => {
          afterFiter = this.data.filter(
            (job) =>
              job.languages.includes(element.innerHTML) ||
              job.tools.includes(element.innerHTML) ||
              job.position.split(` `).includes(element.innerHTML)
          );
        });
        return afterFiter;
      }
    },
  },
};
</script>

<style lang="scss">
.filter {
  background-color: white;
  width: 92%;
  margin: auto;
  padding: 10px;
  margin-top: -40px;
  display: flex;
  justify-content: space-between;
  p.clear {
    color: hsl(180, 29%, 50%);
    cursor: pointer;
  }
  p.clear:hover {
    border-bottom: 1px solid hsl(180, 29%, 50%);
  }
  .spans {
    span {
      background-color: hsl(180, 31%, 95%);
      color: hsl(180, 29%, 50%);
      padding: 5px;
      margin-top: 0.5em;
    }
    button {
      border: none;
      cursor: pointer;
      background-color: hsl(180, 29%, 50%);
      padding: 4px;
      margin-right: 20px;
    }
    button:hover {
      background-color: hsl(180, 14%, 20%);
    }
  }
}
.job.featured {
  border-left: 2px solid hsl(180, 29%, 50%);
}
.job {
  background-color: white;
  display: flex;
  justify-content: space-around;
  width: 90%;
  margin: 20px auto;
  padding: 20px;
  .company {
    display: flex;
    width: 60%;
    .text {
      margin-left: 10px;
      span {
        margin-right: 20px;
      }
      span.name {
        color: hsl(180, 29%, 50%);
      }
      span.new {
        background-color: hsl(180, 29%, 50%);
        color: white;
        border-radius: 10px;
        padding: 3px;
      }
      span.featured {
        background-color: hsl(180, 14%, 20%);
        color: white;
        border-radius: 15px;
        padding: 5px;
      }
    }
    .last-line {
      span {
        color: hsl(180, 8%, 52%);
      }
    }
  }
  .lang {
    ul {
      display: flex;
      text-decoration: none;
      list-style: none;
      justify-content: space-between;
      width: 100%;
      li {
        background-color: hsl(180, 31%, 95%);
        color: hsl(180, 29%, 50%);
        padding: 5px;
        cursor: pointer;
      }
      li:hover {
        color: white;
        background-color: hsl(180, 29%, 50%);
      }
    }
  }
}
</style>
